export default function Home() {
  return <div>Dashboard</div>;
}
